import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { Button, CircleIcon, DocumentMedicineIcon } from "@/shared/ui";
import { DocumentCard } from ".";

export const DocumentCenterDoctorNotes = () => {
  return (
    <DocumentCard.Root>
      <DocumentCard.Banner className="bg-secondary-100">
        <CircleIcon icon={DocumentMedicineIcon} size="lg" />
      </DocumentCard.Banner>

      <DocumentCard.Content>
        <DocumentCard.Title>{t`Doctor's Notes`}</DocumentCard.Title>
        <DocumentCard.Description>{t`Access your doctor's notes and recommendations.`}</DocumentCard.Description>
      </DocumentCard.Content>

      <DocumentCard.Actions>
        <Button asChild variant="secondary" size="lg">
          <Link
            to={ROUTES.DOCUMENT_CENTER.DOCTOR_NOTES}
          >{t`View details`}</Link>
        </Button>
      </DocumentCard.Actions>
    </DocumentCard.Root>
  );
};
